var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout",class:{ 'layout--collapsed': _vm.isCollapsed }},[_c('sidebar'),_c('div',{staticClass:"layout__main"},[_c('app-header'),_c('div',{staticClass:"layout__content"},[_c('router-view',{key:_vm.$route.path})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }